import { DatePicker, Tooltip, TimePicker, message } from "antd";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import EmojiPicker from 'emoji-picker-react';
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import TaskServices from "../../../Services/TaskServices";
import ProjectServices from "../../../Services/ProjectServices";
import DataParser from "../../../utlits/Dataparser";
import secureLocalStorage from "react-secure-storage";
import UserServices from "../../../Services/UserService";
import SocketService from "../../../Services/SocketService";
import Select from "react-select";
import SprintServices from "../../../Services/SprintServices";
import { useAdvancedTaskModule } from "../../../hooks/useAdvancedTaskModule";
import UserProfile from "../../Reuseable/UserProfile..jsx";

const CreateTask = (props) => {
  const {
    priority,
    reFreshData,
    id,
    labelledby,
    parentId,
    parentDueDate,
    parentTaskPriority,
    closeBtnId,
    initialProjectId,
    initialProjectName,
    projects: propProjects,
  } = props;

  // Optional (Notes "promote to task"): the title the form starts with. Read through a ref because the
  // modal show/hide listeners below are registered once. Callers that don't pass it get an empty title.
  const initialTitleRef = useRef(props.initialTitle || "");
  initialTitleRef.current = props.initialTitle || "";
  // Optional (Notes "@name"): the person the form starts assigned to; otherwise the current user, as before.
  const initialAssigneeRef = useRef(props.initialAssignee || "");
  initialAssigneeRef.current = props.initialAssignee || "";

  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  // users list is now sourced from props.taskOwner (hierarchy-scoped, same as task listing)
  const [description, setDescription] = useState("");
  const [isDescFocused, setIsDescFocused] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [emojiPickerPos, setEmojiPickerPos] = useState({ top: 0, left: 0 });
  const emojiPickerRef = React.useRef(null);
  const linkPopoverRef = React.useRef(null);
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkPopoverPos, setLinkPopoverPos] = useState({ top: 0, left: 0 });
  const quillRef = React.useRef(null);
  const clickedLinkRef = React.useRef({ index: null, length: null });
  const [assignedTo, setAssignedTo] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [periority, setPeriority] = useState("");
  const [taskPriority, setTaskPriority] = useState(() => parentId ? (parentTaskPriority || 'normal') : 'normal');
  const [bumpToFront, setBumpToFront] = useState(false);
  const [showCriticalPrompt, setShowCriticalPrompt] = useState(false);
  const [showPriorityDropdown, setShowPriorityDropdown] = useState(false);
  const [assignedToError, setAssignedToError] = useState(false);
  const [periorityError, setPeriorityError] = useState(false);
  const [status, setStatus] = useState("");
  const [statusError, setStatusError] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [showAllAttachments, setShowAllAttachments] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [recurringPeriod, setRecurringPeriod] = useState("");
  const [recurringTime, setRecurringTime] = useState("09:00");
  const [recurringTotalCount, setRecurringTotalCount] = useState(0);
  const [recurringExcludeDays, setRecurringExcludeDays] = useState([]);
  const [recurringWeekDay, setRecurringWeekDay] = useState("");
  const [recurringMonthDate, setRecurringMonthDate] = useState("");
  const [recurringAnnualMonth, setRecurringAnnualMonth] = useState("");
  const [recurringAnnualDate, setRecurringAnnualDate] = useState("");
  const [isRecurrenceMonthMenuOpen, setIsRecurrenceMonthMenuOpen] = useState(false);
  const [effortHours, setEffortHours] = useState("");
  const [effortUnit, setEffortUnit] = useState('hours');
  const [showUnitDropdown, setShowUnitDropdown] = useState(false);
  const [effortHoursFocused, setEffortHoursFocused] = useState(false);
  const [effortHoursError, setEffortHoursError] = useState(false);
  const effortBaseMinutes = useRef(null);
  const [dependsOn, setDependsOn] = useState([]);
  const [depSearchTerm, setDepSearchTerm] = useState("");
  const [depSearchOpen, setDepSearchOpen] = useState(false);
  const [localTaskList, setLocalTaskList] = useState(null);
  const hasAdvancedTaskModule = useAdvancedTaskModule();
  const canSetCritical = hasAdvancedTaskModule && (!parentId || parentTaskPriority === 'critical');
  const [showCriticalOrderModal, setShowCriticalOrderModal] = useState(false);
  const [criticalOrderList, setCriticalOrderList] = useState([]);
  const [dragCriticalIdx, setDragCriticalIdx] = useState(null);
  const [loadingCriticals, setLoadingCriticals] = useState(false);
  // tracks whether the assignee already has other critical tasks when the prompt opens
  const [assigneeHasCriticals, setAssigneeHasCriticals] = useState(false);
  const pendingReorderRef = useRef(null);
  const [formResetKey, setFormResetKey] = useState(0);
  const selectRef = useRef(null);
  const descBlurTimeoutRef = useRef(null);
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const insertImageFromFile = (file) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const img = new Image();
      img.onload = () => {
        const MAX = 1200;
        const canvas = document.createElement('canvas');
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) { const r = Math.min(MAX / w, MAX / h); w = Math.round(w * r); h = Math.round(h * r); }
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        const base64 = canvas.toDataURL('image/jpeg', 0.85);
        const quill = quillRef.current?.getEditor();
        if (!quill) return;
        const range = quill.getSelection(true);
        quill.insertEmbed(range.index, 'image', base64);
        quill.setSelection(range.index + 1);
      };
      img.src = evt.target.result;
    };
    reader.readAsDataURL(file);
  };
  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;
    const handlePaste = (e) => {
      const imgItem = Array.from(e.clipboardData?.items || []).find(i => i.type.startsWith('image/'));
      if (!imgItem) return;
      e.stopPropagation(); e.preventDefault();
      const f = imgItem.getAsFile();
      if (f) insertImageFromFile(f);
    };
    editor.root.addEventListener('paste', handlePaste);
    return () => editor.root.removeEventListener('paste', handlePaste);
  }, []);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [sprints, setSprints] = useState([]);
  const [sprintId, setSprintId] = useState(null);
  const [isSprintsLoading, setIsSprintsLoading] = useState(false);

  const companyId = DataParser.CompanyId();
  const companyIdentifier = DataParser.CompanyIdentifier();

  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [localUsers, setLocalUsers] = useState([]);

  const [approval, setApproval] = useState(0);
  const [isApprovalMenuOpen, setIsApprovalMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isPriorityMenuOpen, setIsPriorityMenuOpen] = useState(false);
  const [isStatusMenuOpen, setIsStatusMenuOpen] = useState(false);
  const [isRecurringMenuOpen, setIsRecurringMenuOpen] = useState(false);
  const [isRecurrencePeriodMenuOpen, setIsRecurrencePeriodMenuOpen] = useState(false);

  // Use hierarchy-scoped taskOwner from parent when available; fall back to direct fetch
  const effectiveUsers = (props.taskOwner && props.taskOwner.length > 0) ? props.taskOwner : localUsers;
  const filteredUserOptions = effectiveUsers
    .map(user => ({ value: user.id, label: user.full_name || `${user.first_name || ''} ${user.last_name || ''}`.trim() }))
    .filter(option => option.label.toLowerCase().includes(userSearchTerm.toLowerCase()))
    .slice(0, 10);

  const actionSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "none",
      background: "transparent",
      boxShadow: "none",
      minHeight: "34px",
      fontSize: "13px",
      cursor: "pointer",
      width: "auto",
      minWidth: "80px",
      "&:hover": { border: "none" },
    }),
    valueContainer: (provided) => ({ ...provided, padding: "0 2px" }),
    singleValue: (provided) => ({ ...provided, color: "#1D1D1D", fontWeight: "600" }),
    placeholder: (provided) => ({ ...provided, color: "#a0a0a0", fontWeight: "500" }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
      zIndex: 9999,
      border: "1px solid #E8E8E8",
      padding: "5px",
      width: "250px"
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: state.isFocused ? "#f0fdf9" : "transparent",
      color: "#1a1a1a",
      borderRadius: "6px",
      margin: "2px 0",
      cursor: "pointer",
      "&:active": { backgroundColor: "#F5F5F5" },
    }),
    input: (provided) => ({ ...provided, color: "#1D1D1D" }),
  };

  useEffect(() => {
    const userId = DataParser.UserId();
    const datee = DataParser.getDateinFormat();

    setDueDate(datee);
    setStatus("Pending");
    setAssignedTo(userId);
    setPeriority("");
    setTitle("");
    setDescription("");
    setAttachments([]);
    setIsRecurring(false);
    setRecurringPeriod("");
    setEffortHours("");
    setEffortUnit('hours');

    // Fetch users directly as fallback so company admin always sees the full list
    UserServices.getDepartmentUsernames(companyId)
      .then((res) => {
        if (res.Good && res.data?.user) setLocalUsers(res.data.user);
      })
      .catch(() => {});

    const fetchProjects = () => {
      // Only id and name are used here: the light list, same as Tasks.jsx passes in. The full list builds
      // every project's tasks (1.2 MB) and froze the backend for seconds on every page (Sidebar mounts this)
      ProjectServices.getAllProjectsForAssignment(companyId)
        .then((res) => {
          if (res.Good) {
            setProjects(res.data.projects || []);
          }
        })
        .catch((err) => console.error("Error fetching projects:", err));
    };

    if (!propProjects || propProjects.length === 0) {
      fetchProjects();
    }

    SocketService.connect();

    const handleClickOutside = (event) => {
      // User menu
      if (!event.target.closest('.user-select-container')) {
        setIsUserMenuOpen(false);
        setUserSearchTerm("");
      }
      // Priority menu
      if (!event.target.closest('.priority-select-container')) {
        setIsPriorityMenuOpen(false);
      }
      // Status menu
      if (!event.target.closest('.status-select-container')) {
        setIsStatusMenuOpen(false);
      }
      // Recurring menu
      if (!event.target.closest('.recurring-select-container')) {
        setIsRecurringMenuOpen(false);
      }
      // Dependency menu
      if (!event.target.closest('.dep-select-container')) {
        setDepSearchOpen(false);
      }
      // Recurrence Period menu
      if (!event.target.closest('.recurrence-period-select-container')) {
        setIsRecurrencePeriodMenuOpen(false);
      }
      // Approval menu
      if (!event.target.closest('.approval-select-container')) {
        setIsApprovalMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [companyId, propProjects]);

  // Reset effort fields every time the modal opens so stale state from a previous
  // dismissed session (e.g. user changed unit to 'hours' then closed without saving)
  // never carries over and causes effort × 60 double-conversion.
  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const resetEffortOnOpen = () => {
      setEffortHours("");
      setEffortUnit('hours');
      effortBaseMinutes.current = null;
      setEffortHoursError(false);
    };
    el.addEventListener('show.bs.modal', resetEffortOnOpen);
    return () => el.removeEventListener('show.bs.modal', resetEffortOnOpen);
  }, [id]);

  useEffect(() => {
    if (propProjects && propProjects.length > 0) {
      setProjects(propProjects);
    }
  }, [propProjects]);

  useEffect(() => {
    if (projectId && projectId.value) {
      setIsSprintsLoading(true);
      SprintServices.getSprints(companyId, projectId.value)
        .then(res => {
          if (res.Good) {
            setSprints(res.data || []);
          }
        })
        .finally(() => setIsSprintsLoading(false));
    } else {
      setSprints([]);
      setSprintId(null);
    }
  }, [projectId, companyId]);

  const addAttachment = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAttachments((prev) => [...prev, file]);
    e.target.value = null;
  };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const previewAttachment = (file) => {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Lazy-load task list for dependency search when parent doesn't provide allTasks
  useEffect(() => {
    if (!depSearchOpen) return;
    if (props.allTasks !== undefined) return;
    if (localTaskList !== null) return;
    Promise.all([
      TaskServices.getAllTask(companyId),
      TaskServices.getDueTodayTask(companyId)
    ])
      .then(([resAll, resToday]) => {
        const dAll = resAll?.data;
        const dToday = resToday?.data;
        const flat = [
          ...(Array.isArray(dAll?.tasks_assigned_to_me) ? dAll.tasks_assigned_to_me : []),
          ...(Array.isArray(dAll?.tasksByme) ? dAll.tasksByme : []),
          ...(Array.isArray(dAll?.all_other_tasks) ? dAll.all_other_tasks : []),
          ...(Array.isArray(dToday?.tasks_assigned_to_me) ? dToday.tasks_assigned_to_me : []),
          ...(Array.isArray(dToday?.tasksByme) ? dToday.tasksByme : []),
          ...(Array.isArray(dToday?.all_other_tasks) ? dToday.all_other_tasks : []),
        ];
        const seen = new Set();
        setLocalTaskList(flat.filter(t => { if (!t || !t.id || seen.has(t.id)) return false; seen.add(t.id); return true; }));
      })
      .catch(() => setLocalTaskList([]));
  }, [depSearchOpen, props.allTasks, localTaskList, companyId]);

  const depTaskList = props.allTasks ?? localTaskList ?? [];

  // Auto-determine status when assignee changes: "In-Progress" if no active tasks, else "Pending"
  useEffect(() => {
    if (!assignedTo) return;
    const taskList = props.allTasks !== undefined ? props.allTasks : localTaskList;
    if (taskList === null) return; // task list not loaded yet, keep existing default
    const EXCLUDED_STATUSES = [
      'Complete', 'Completed', 'Done', 'Closed', 'Cancelled', 'cancelled', 'completed',
      'On Hold', 'On-Hold',
      'Pending-Approval', 'Pending Approval',
    ];
    const hasActiveTasks = taskList.some(
      t => String(t.asigned_to) === String(assignedTo) && !EXCLUDED_STATUSES.includes(t.status)
    );
    setStatus(hasActiveTasks ? 'Pending' : 'In-Progress');
  }, [assignedTo, props.allTasks, localTaskList, formResetKey]);

  const resetForm = () => {
    const userId = DataParser.UserId();
    const datee = DataParser.getDateinFormat();
    setTitle(initialTitleRef.current);
    setAssignedTo(initialAssigneeRef.current || userId);
    setDueDate(datee);
    setPeriority("");
    setTaskPriority("normal");
    setStatus("Pending");
    setDescription("");
    setAttachments([]);
    setApproval(0);
    setIsRecurring(false);
    setRecurringPeriod("");
    setRecurringTime("09:00");
    setRecurringTotalCount(0);
    setAssignedToError(false);
    setPeriorityError(false);
    setStatusError(false);
    setEffortHours("");
    setEffortUnit('hours');
    effortBaseMinutes.current = null;
    setEffortHoursError(false);
    setApproval(0);
    setIsApprovalMenuOpen(false);
    setDependsOn([]);
    setDepSearchTerm("");
    setDepSearchOpen(false);
    setLocalTaskList(null);
    setAssigneeHasCriticals(false);
    setBumpToFront(false);
    if (initialProjectId) {
      const foundProject = projects.find(p => String(p.id || p._id) === String(initialProjectId));
      if (foundProject) {
        setProjectId({ value: foundProject.id || foundProject._id, label: foundProject.name });
      } else {
        setProjectId({ value: initialProjectId, label: initialProjectName || "Loading Project..." });
      }
    } else {
      setProjectId(null);
    }
    setSprintId(null);
    setIsSubmitting(false);
    setFormResetKey(k => k + 1);
  };

  useEffect(() => {
    const modalEl = document.getElementById(id);
    const handleHide = () => resetForm();
    const handleShow = () => resetForm();
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleHide);
      modalEl.addEventListener("show.bs.modal", handleShow);
    }
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleHide);
        modalEl.removeEventListener("show.bs.modal", handleShow);
      }
    };
  }, [id]);

  useEffect(() => {
    if (initialProjectId) {
      const foundProject = projects.find(p => String(p.id || p._id) === String(initialProjectId));
      if (foundProject) {
        setProjectId({ value: foundProject.id || foundProject._id, label: foundProject.name });
      } else {
        setProjectId({ value: initialProjectId, label: initialProjectName || "Loading Project..." });
      }
    }
  }, [initialProjectId, initialProjectName, projects]);

  const handleSubmit = async (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (isSubmitting) return;

    const missing = [];
    if (!title?.trim()) missing.push("Title");
    if (!assignedTo) missing.push("Assigned To");
    if (status === "") missing.push("Status");

    setAssignedToError(!assignedTo);
    setStatusError(status === "");

    if (missing.length > 0) {
      message.error(`Please fill in required fields: ${missing.join(", ")}`);
      return;
    }

    if (isRecurring && !recurringPeriod) {
      message.error("Please select a recurrence period for recurring tasks!");
      return;
    }

    if (hasAdvancedTaskModule && effortHours === "") {
      setEffortHoursError(true);
      message.error("Effort is required");
      return;
    }

    if (hasAdvancedTaskModule && Number(effortHours) <= 0) {
      setEffortHoursError(true);
      message.error("Effort hours must be greater than 0");
      return;
    }

    setEffortHoursError(false);

    const selectedSprint = sprints.find(s => String(s.id) === String(sprintId?.value));

    // Skip due-date bound checks when advanced module is active (scheduling engine computes it)
    const dueDateIsComputed = hasAdvancedTaskModule;

    if (!dueDateIsComputed) {
      if (selectedSprint && moment(dueDate).isAfter(moment(selectedSprint.due_date), 'day')) {
        message.error(`Task due date cannot be later than sprint due date (${moment(selectedSprint.due_date).format("MMM D, YYYY")})`);
        return;
      }

      if (parentId && parentDueDate && dueDate && moment(dueDate).isAfter(moment(parentDueDate), 'day')) {
        message.error(`Subtask due date cannot exceed parent task due date (${moment(parentDueDate).format("MMM D, YYYY")})`);
        return;
      }
    }

    setIsSubmitting(true);

    const body = {
      company_id: companyId,
      company_identifier: companyIdentifier,
      title,
      assign_to: assignedTo,
      due_date: hasAdvancedTaskModule ? null : moment(dueDate).format("YYYY-MM-DD"),
      task_priority: taskPriority,
      ...(hasAdvancedTaskModule && bumpToFront && { bump_to_front: true }),
      status,
      description,
      is_recurring: isRecurring,
      recurring_period: recurringPeriod,
      recurring_time: recurringTime,
      recurring_total_count: recurringTotalCount,
      recurring_exclude_days: recurringExcludeDays,
      recurring_week_day: recurringWeekDay,
      recurring_month_date: recurringMonthDate,
      recurring_annual_month: recurringAnnualMonth,
      recurring_annual_date: recurringAnnualDate,
      approval_required: approval,
      project_id: projectId ? projectId.value : (props.projectId || 0),
      sprint_id: sprintId ? sprintId.value : null,
      parent_id: parentId || 0,
      approval_required: approval,
      ...(hasAdvancedTaskModule && effortHours !== "" && {
        effort_hours: effortUnit === 'minutes' ? Number(effortHours) : effortUnit === 'hours' ? Number(effortHours) * 60 : Number(effortHours) * 8 * 60,
        effort_unit: effortUnit,
      }),
      ...(hasAdvancedTaskModule && dependsOn.length > 0 && { depends_on: dependsOn.map(d => d.id) }),
    };

    // Close modal immediately and inject optimistic entry into the task list
    const optimisticId = `opt_${Date.now()}`;
    if (props.onOptimisticTask) {
      props.onOptimisticTask({
        id: optimisticId,
        title,
        status,
        task_priority: taskPriority,
        asigned_to: String(assignedTo),
        assignee: String(DataParser.UserId()),
        due_date: null,
        _optimistic: true,
      });
    }
    const closeBtn = document.getElementById(closeBtnId || "taskClose");
    if (closeBtn) closeBtn.click();
    if (!parentId) props.onTaskCreated?.();

    try {
      let res;
      if (parentId && parentId !== 0) {
        res = await TaskServices.createSubTask(parentId, body);
      } else {
        res = await TaskServices.createTask(body);
      }

      if (res.Good) {
        const newTaskId = res.data?.id || res.inserted_id || res.task_id;
        const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));
        const checkAuth = adminInfo ? adminInfo.authToken : "";

        const uploadPromises = attachments.map((file) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("company_id", companyId);
          formData.append("company_identifier", companyIdentifier);

          return axios.post(
            `${process.env.REACT_APP_BASE_URL}tasks/attachments/${newTaskId}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                authToken: checkAuth,
              },
            }
          ).catch(() => message.error(`Failed to upload "${file.name}"`));
        });

        await Promise.all(uploadPromises);
        message.success("Task created successfully!");
        // the project is still in Planning: the task was saved On Hold until the project starts
        if (res?.planning_hold && res?.message) message.info(res.message);
        // Optional: tell the caller which task was created (Notes uses it to link the note to its task)
        if (props.onCreated) props.onCreated({ ...(res.data || {}), id: newTaskId });

        if (pendingReorderRef.current && newTaskId) {
          const orderedIds = pendingReorderRef.current.map(id => id === '__new__' ? Number(newTaskId) : Number(id));
          TaskServices.reorderCritical({ orderedIds, company_id: companyId })
            .catch(err => console.error('reorderCritical after create failed:', err));
          pendingReorderRef.current = null;
        }
        // Do NOT call recalculateSchedule here — exports.create already calls rescheduleUserQueue
        // with the correct queue-based dates. recalculateSchedule uses "now" as earliestStart
        // (ignoring the queue) and emits a schedule_update with wrong "now + effort" dates,
        // which overwrites the correct queue-scheduled dates that rescheduleUserQueue just set.

        if (props.onOptimisticTask) {
          // Optimistic mode (Tasks page): socket handles create + schedule_update events.
          // No reload needed — the socket patches the list in-place without disturbing the table.
        } else if (reFreshData) {
          // Non-optimistic context (e.g. EditProject) — refresh immediately as before.
          reFreshData(e);
        }
      } else {
        if (props.onRemoveOptimisticTask) props.onRemoveOptimisticTask(optimisticId);
        message.error(res.data || "Failed to create task.");
      }
    } catch (err) {
      console.error("Task creation failed:", err);
      if (props.onRemoveOptimisticTask) props.onRemoveOptimisticTask(optimisticId);
      const errorMsg = err.response?.data?.data || err.response?.data?.message || "Failed to create task.";
      message.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!showLinkInput) return;
    const handleOutside = (e) => {
      if (linkPopoverRef.current && !linkPopoverRef.current.contains(e.target)) {
        setShowLinkInput(false);
        setLinkUrl('');
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [showLinkInput]);


  useEffect(() => {
    const quill = quillRef.current?.getEditor?.();
    if (!quill) return;
    const isUrl = (s) => /^(https?:\/\/|www\.)\S+$/.test(s);
    const toHref = (s) => /^https?:\/\//i.test(s) ? s : 'https://' + s;
    const handler = (delta, oldDelta, source) => {
      if (source !== 'user') return;
      const last = delta.ops[delta.ops.length - 1];
      if (!last || typeof last.insert !== 'string') return;
      if (!/\s$/.test(last.insert)) return;
      let pos = 0;
      for (const op of delta.ops) {
        if (op.retain) pos += op.retain;
        else if (typeof op.insert === 'string') pos += op.insert.length;
      }
      const text = quill.getText(0, pos);
      const m = text.match(/(\S+)\s+$/);
      if (!m) return;
      const word = m[1];
      if (!isUrl(word)) return;
      const wordEnd = text.trimEnd().length;
      const wordStart = wordEnd - word.length;
      if (quill.getFormat(wordStart, word.length).link) return;
      quill.formatText(wordStart, word.length, 'link', toHref(word), 'api');
    };
    quill.on('text-change', handler);
    return () => quill.off('text-change', handler);
  }, []);

  const quillModules = useMemo(() => ({
    toolbar: false,
    keyboard: {
      bindings: {
        autoLink: {
          key: 32,
          handler(range) {
            const q = this.quill;
            const text = q.getText(0, range.index);
            const m = text.match(/(\S+)$/);
            if (m) {
              const word = m[1];
              if (/^(https?:\/\/|www\.)\S+$/.test(word)) {
                const wordStart = range.index - word.length;
                if (!q.getFormat(wordStart, word.length).link) {
                  const href = /^https?:\/\//i.test(word) ? word : 'https://' + word;
                  q.formatText(wordStart, word.length, 'link', href, 'user');
                }
              }
            }
            return true;
          }
        }
      }
    }
  }), []);

  const openLinkPopover = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const popW = 320, popH = 60;
    let top = rect.top - popH - 8;
    if (top < 8) top = rect.bottom + 8;
    top = Math.max(8, Math.min(top, window.innerHeight - popH - 8));
    let left = rect.left;
    if (left + popW > window.innerWidth - 8) left = window.innerWidth - popW - 8;
    left = Math.max(8, left);
    const quill = quillRef.current.getEditor();
    const format = quill.getFormat();
    if (format.link) {
      setLinkUrl(format.link);
      const range = quill.getSelection();
      if (range) {
        const [leaf] = quill.getLeaf(range.index);
        let blot = leaf;
        const Quill = ReactQuill.Quill;
        while (blot && blot.statics.blotName !== 'link' && blot !== quill.scroll) { blot = blot.parent; }
        if (blot && blot.statics.blotName === 'link') {
          clickedLinkRef.current = { index: quill.getIndex(blot), length: blot.length() };
        } else {
          clickedLinkRef.current = { index: null, length: null };
        }
      }
    } else {
      setLinkUrl("");
      clickedLinkRef.current = { index: null, length: null };
    }
    setLinkPopoverPos({ top, left });
    setShowLinkInput(v => !v);
  };

  const linkPortal = showLinkInput && ReactDOM.createPortal(
    <>
      <div style={{ position: 'fixed', inset: 0, zIndex: 999998 }} onMouseDown={e => { e.preventDefault(); e.stopPropagation(); setShowLinkInput(false); setLinkUrl(""); clickedLinkRef.current = { index: null, length: null }; }} />
      <div ref={linkPopoverRef} style={{ position: 'fixed', top: linkPopoverPos.top, left: linkPopoverPos.left, zIndex: 999999, background: '#fff', border: '1.5px solid #1D1D1D', borderRadius: '10px', padding: '4px', width: '320px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }} onMouseDown={e => e.stopPropagation()}>
        <div className="d-flex gap-2 align-items-center">
          <input type="text" className="link-portal-input" placeholder="Paste or type a link..." style={{ border: 'none', outline: 'none', boxShadow: 'none', fontSize: '14px', padding: '6px 8px', background: 'transparent', flex: 1, minWidth: 0 }} value={linkUrl} onChange={e => setLinkUrl(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                const quill = quillRef.current.getEditor();
                const { index, length } = clickedLinkRef.current;
                if (index !== null && length !== null) { quill.formatText(index, length, 'link', linkUrl); } else { quill.format('link', linkUrl); }
                setShowLinkInput(false); setLinkUrl(""); clickedLinkRef.current = { index: null, length: null };
              }
            }}
          />
          {linkUrl && (
            <a href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`} target="_blank" rel="noopener noreferrer" className="toolbar-btn d-flex align-items-center justify-content-center" style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #1D1D1D', color: '#1D1D1D', textDecoration: 'none', background: '#fff' }} title="Open link in new tab">
              <i className="uil uil-external-link-alt" style={{ fontSize: '18px' }} />
            </a>
          )}
          {linkUrl && (
            <button type="button" className="toolbar-btn d-flex align-items-center justify-content-center" style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #ff4d4f', color: '#ff4d4f', background: '#fff' }} title="Remove link"
              onClick={() => {
                const quill = quillRef.current.getEditor();
                const { index, length } = clickedLinkRef.current;
                if (index !== null && length !== null) { quill.formatText(index, length, 'link', false); } else { quill.format('link', false); }
                setShowLinkInput(false); setLinkUrl(""); clickedLinkRef.current = { index: null, length: null };
              }}>
              <i className="uil uil-link-broken" style={{ fontSize: '18px' }} />
            </button>
          )}
          <button type="button" className="link-apply-btn" onClick={() => {
            const quill = quillRef.current.getEditor();
            const { index, length } = clickedLinkRef.current;
            if (index !== null && length !== null) { quill.formatText(index, length, 'link', linkUrl); } else { quill.format('link', linkUrl); }
            setShowLinkInput(false); setLinkUrl(""); clickedLinkRef.current = { index: null, length: null };
          }}>Apply</button>
        </div>
      </div>
    </>,
    document.body
  );

  const openEmojiPicker = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const pickerH = 420, pickerW = 350;
    const spaceBelow = window.innerHeight - rect.bottom - 8;
    const spaceAbove = rect.top - 8;
    let top = spaceBelow >= pickerH || spaceBelow >= spaceAbove
      ? rect.bottom + 8
      : rect.top - pickerH - 8;
    top = Math.max(8, Math.min(top, window.innerHeight - pickerH - 8));
    let left = rect.left;
    if (left + pickerW > window.innerWidth - 8) left = window.innerWidth - pickerW - 8;
    left = Math.max(8, left);
    setEmojiPickerPos({ top, left });
    setShowEmojiPicker(v => !v);
  };

  const emojiPortal = showEmojiPicker && ReactDOM.createPortal(
    <>
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 999998 }}
        onMouseDown={e => { e.preventDefault(); e.stopPropagation(); setShowEmojiPicker(false); }}
        onClick={e => { e.preventDefault(); e.stopPropagation(); }}
      />
      <div
        ref={emojiPickerRef}
        style={{ position: 'fixed', top: emojiPickerPos.top, left: emojiPickerPos.left, zIndex: 999999, boxShadow: '0 8px 32px rgba(0,0,0,0.2)', borderRadius: 12, overflow: 'hidden' }}
        onMouseDown={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
      >
        <EmojiPicker onEmojiClick={emojiData => {
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection();
          if (range) {
            if (range.length > 0) quill.deleteText(range.index, range.length);
            quill.insertText(range.index, emojiData.emoji);
            quill.setSelection(range.index + emojiData.emoji.length);
          } else {
            quill.insertText(quill.getLength(), emojiData.emoji);
          }
          setShowEmojiPicker(false);
        }} width={350} height={420} />
      </div>
    </>,
    document.body
  );

  return <>{ReactDOM.createPortal(
    <div
      className="modal fade"
      id={id}
      tabIndex={-1}
      aria-labelledby={labelledby}
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{ zIndex: 100020 }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "850px" }}>
        <div className="modal-content" style={{ borderRadius: "24px", border: "none", padding: "10px 18px 20px 18px", boxShadow: "0 10px 40px rgba(0,0,0,0.12)" }}>
          <div className="modal-header border-0 pb-2 d-flex justify-content-end" style={{ paddingBottom: '8px' }}>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id={closeBtnId || "taskClose"}
              onClick={() => resetForm()}
              style={{ fontSize: '18px', backgroundSize: '16px', opacity: 0.8 }}
            />
          </div>
          <div className="modal-body pt-0 px-4 pb-1">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* ── Title Section ────────────────────────────────── */}
                <div className="col-12 mb-2">
                  <div className="float-input-wrap task-title-float-wrap">
                    <input
                      type="text"
                      id="taskTitleInput"
                      className=""
                      placeholder="Enter a task title"
                      value={title}
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                      autoFocus
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        height: "44px",
                        padding: "18px 16px 8px 16px"
                      }}
                    />
                    <label htmlFor="taskTitleInput">Enter a task title</label>
                  </div>
                </div>

                {/* ── Description Section ──────────────────────────────── */}
                <div className="col-12 mb-3">
                  <div
                    className={`float-input-wrap task-desc-float-wrap ${isDescFocused || showLinkInput || showEmojiPicker ? 'focused' : ''} ${(description && description !== '<p><br></p>') ? 'has-value' : ''}`}
                    onClick={(e) => {
                      const anchor = e.target.closest('a');
                      if (anchor && anchor.closest('.ql-editor')) {
                        e.preventDefault();
                        const url = anchor.getAttribute('href');
                        setLinkUrl(url);
                        setShowLinkInput(true);

                        const q = quillRef.current.getEditor();
                        const Quill = ReactQuill.Quill;
                        const blot = Quill.find(anchor);
                        if (blot) {
                          clickedLinkRef.current = {
                            index: q.getIndex(blot),
                            length: blot.length()
                          };
                        }
                      }
                    }}
                  >
                    <ReactQuill
                      ref={quillRef}
                      theme="snow"
                      placeholder=""
                      value={description}
                      onChange={setDescription}
                      onFocus={() => {
                        if (descBlurTimeoutRef.current) {
                          clearTimeout(descBlurTimeoutRef.current);
                          descBlurTimeoutRef.current = null;
                        }
                        setIsDescFocused(true);
                      }}
                      onBlur={() => {
                        descBlurTimeoutRef.current = setTimeout(() => {
                          setIsDescFocused(false);
                        }, 150);
                      }}
                      modules={quillModules}
                      style={{
                        fontSize: "15px",
                      }}
                    />
                    <span className="desc-icon" style={{ display:'inline-block', width:'18px', height:'18px', flexShrink:0, backgroundColor: '#a0a0a0', mask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain" }} />
                    <label>Description</label>

                    {/* ── Custom Toolbar ──────────────────────────────── */}
                    <div className="desc-toolbar" onMouseDown={(e) => e.preventDefault()}>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('bold', !format.bold);
                      }}>
                        <i className="uil uil-bold" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('italic', !format.italic);
                      }}>
                        <i className="uil uil-italic" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('underline', !format.underline);
                      }}>
                        <i className="uil uil-underline" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={openEmojiPicker}>
                        <i className="uil uil-smile" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={openLinkPopover}>
                        <i className="uil uil-link" />
                      </button>
                      <button type="button" className="toolbar-btn" onClick={() => {
                        const quill = quillRef.current.getEditor();
                        const format = quill.getFormat();
                        quill.format('list', format.list === 'bullet' ? false : 'bullet');
                      }}>
                        <i className="uil uil-list-ul" />
                      </button>
                      <button type="button" className="toolbar-btn" title="Insert image" onClick={() => imageInputRef.current?.click()}>
                        <i className="uil uil-image" />
                      </button>
                      <input type="file" ref={imageInputRef} hidden accept="image/*" onChange={(e) => { const f = e.target.files?.[0]; if (f) { insertImageFromFile(f); e.target.value = ''; } }} />
                    </div>
                  </div>
                </div>

{/* ── Action Grid (Horizontal Bar) ─────────────────────── */}
                <div className="col-12 mb-4">
                  <div className="d-flex flex-wrap gap-1 align-items-center">
                    <div className="user-select-container position-relative">
                      <Tooltip title="Assigned To" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                          style={{ borderColor: assignedToError ? '#ff4d4f' : (isUserMenuOpen || assignedTo) ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: assignedTo ? '#1D1D1D' : (assignedToError ? '#ff4d4f' : '#A0A0A0'), mask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: assignedTo ? '#1D1D1D' : (assignedToError ? '#ff4d4f' : '#A0A0A0') }}>
                            {(() => { const u = effectiveUsers.find(u => String(u.id) === String(assignedTo)); return u ? (u.full_name || `${u.first_name || ''} ${u.last_name || ''}`.trim() || "Assigned to") : "Assigned to"; })()}
                          </span>
                        </div>
                      </Tooltip>

                      {isUserMenuOpen && (
                        <div className="custom-user-dropdown">
                          {/* Search Bar */}
                          <div className="search-header">
                            <i className="uil uil-search" />
                            <input
                              autoFocus
                              placeholder="Search or enter email..."
                              value={userSearchTerm}
                              onChange={(e) => setUserSearchTerm(e.target.value)}
                            />
                          </div>

                          {/* User List */}
                          <div className="user-list-scroll">
                            {filteredUserOptions.length > 0 ? (
                              filteredUserOptions.map(option => {
                                const initials = option.label.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
                                return (
                                  <div
                                    key={option.value}
                                    className="user-option-item"
                                    onClick={() => {
                                      setAssignedTo(option.value);
                                      setAssignedToError(false);
                                      setIsUserMenuOpen(false);
                                      setUserSearchTerm("");
                                    }}
                                  >
                                    <div className="user-avatar-mini">{initials}</div>
                                    <span>{option.label}</span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="no-users-found">No members found</div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Effort — gated by Advanced Task Module */}
                    {hasAdvancedTaskModule && (
                      <Tooltip title="Assign Effort" placement="top">
                        <div
                          className="action-btn-wrap"
                          style={{ borderColor: effortHoursError ? '#ff4d4f' : (effortHoursFocused || effortHours) ? '#1D1D1D' : '#E8E8E8', cursor: 'text', gap: '4px' }}
                          onClick={(e) => { if (!e.target.closest('.effort-unit-toggle')) e.currentTarget.querySelector('input')?.focus(); }}
                        >
                          <span style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: effortHours ? '#1D1D1D' : (effortHoursError ? '#ff4d4f' : '#A0A0A0'), mask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain" }} />
                          <div className="effort-unit-toggle" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <span
                              onClick={(e) => { e.stopPropagation(); setShowUnitDropdown(p => !p); }}
                              style={{ fontSize: '10px', fontWeight: '600', color: effortHours ? '#1D1D1D' : '#A0A0A0', cursor: 'pointer', userSelect: 'none', borderRight: '1px solid #E8E8E8', paddingRight: '5px', lineHeight: 1, display: 'flex', alignItems: 'center', gap: '2px' }}
                            >
                              {{ minutes: 'Mins', hours: 'Hrs', days: 'Days' }[effortUnit]}
                              <span style={{ fontSize: '7px' }}>▾</span>
                            </span>
                            {showUnitDropdown && (
                              <>
                                <div style={{ position: 'fixed', inset: 0, zIndex: 9996 }} onClick={() => setShowUnitDropdown(false)} />
                                <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: '6px', background: '#fff', border: '1px solid #E8E8E8', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 9997, minWidth: '95px', overflow: 'hidden' }}>
                                  {[{ value: 'minutes', label: 'Minutes' }, { value: 'hours', label: 'Hours' }, { value: 'days', label: 'Days' }].map(u => (
                                    <div
                                      key={u.value}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (u.value !== effortUnit) {
                                          const baseMin = effortBaseMinutes.current ?? 0;
                                          const converted = u.value === 'minutes' ? baseMin
                                                          : u.value === 'hours'   ? baseMin / 60
                                                          :                         baseMin / (8 * 60);
                                          setEffortHours(u.value === 'minutes' ? String(Math.round(converted)) : String(parseFloat(converted.toFixed(4))));
                                        }
                                        setEffortUnit(u.value);
                                        setShowUnitDropdown(false);
                                      }}
                                      style={{ padding: '8px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: effortUnit === u.value ? '600' : '400', background: effortUnit === u.value ? '#f5f5f5' : '#fff', color: '#1D1D1D' }}
                                    >
                                      {u.label}
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                          </div>
                          <input
                            type="number"
                            className="no-spinner effort-btn-input"
                            placeholder={{ minutes: 'Mins', hours: 'Hrs', days: 'Days' }[effortUnit]}
                            min="0"
                            step={effortUnit === 'hours' ? '0.5' : '1'}
                            value={effortHours}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              setEffortHours(e.target.value);
                              if (e.target.value) setEffortHoursError(false);
                              const v = Number(e.target.value) || 0;
                              effortBaseMinutes.current = effortUnit === 'minutes' ? v : effortUnit === 'hours' ? v * 60 : v * 8 * 60;
                            }}
                            onFocus={() => setEffortHoursFocused(true)}
                            onBlur={() => setEffortHoursFocused(false)}
                            style={{ border: 'none', background: 'transparent', outline: 'none', fontSize: '11px', fontWeight: '600', color: effortHours ? '#1D1D1D' : '#A0A0A0', width: '28px', padding: '0', fontFamily: 'inherit', cursor: 'text' }}
                          />
                        </div>
                      </Tooltip>
                    )}

                    {/* Due Date — not shown when Advanced Task Module is active (scheduling engine computes it) */}
                    {!hasAdvancedTaskModule && (
                      <Tooltip title="Due Date" placement="top">
                        <div className="action-btn-wrap" style={{ borderColor: dueDate ? '#1D1D1D' : '#E8E8E8' }}>
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: dueDate ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain" }} />
                          <DatePicker
                            value={dueDate ? moment(dueDate) : null}
                            onChange={(date) => setDueDate(date)}
                            format="DD MMM"
                            placeholder="Due Date"
                            className="action-datepicker"
                            bordered={false}
                            allowClear={false}
                            suffixIcon={null}
                            disabledDate={(current) => {
                              if (current && current < moment().startOf('day')) return true;
                              if (parentDueDate && current && current.isAfter(moment(parentDueDate).endOf('day'))) return true;
                              return false;
                            }}
                          />
                        </div>
                      </Tooltip>
                    )}

                    {/* Priority */}
                    {canSetCritical ? (
                      <div style={{ position: 'relative' }}>
                        <Tooltip title="Select Priority" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          style={{ borderColor: '#1D1D1D' }}
                          onClick={() => setShowPriorityDropdown(p => !p)}
                        >
                          <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0, backgroundColor: taskPriority === 'critical' ? '#FF4D4F' : '#0DDFAB' }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#1D1D1D' }}>{taskPriority === 'critical' ? 'Critical' : 'Normal'}</span>
                        </div>
                        </Tooltip>
                        {showPriorityDropdown && (
                          <>
                            <div style={{ position: 'fixed', inset: 0, zIndex: 9998 }} onClick={() => setShowPriorityDropdown(false)} />
                            <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: '4px', background: '#fff', border: '1px solid #E8E8E8', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 9999, minWidth: '140px', overflow: 'hidden' }}>
                              {[{ value: 'normal', label: 'Normal', color: '#0DDFAB' }, { value: 'critical', label: 'Critical', color: '#FF4D4F' }]
                                .filter(opt => !(opt.value === 'normal' && parentId && parentTaskPriority === 'critical'))
                                .filter(opt => !(opt.value === 'critical' && !canSetCritical))
                                .map(opt => (
                                <div
                                  key={opt.value}
                                  onClick={() => {
                                    setShowPriorityDropdown(false);
                                    if (opt.value === 'critical') {
                                      const COMPLETE = ['Complete', 'Completed', 'Done', 'Closed', 'Cancelled', 'cancelled', 'completed'];
                                      const IN_PROGRESS_ST = ['In Progress', 'In-Progress', 'In Review', 'In Testing'];
                                      const hasExistingCriticals = assignedTo && depTaskList.some(
                                        t => t.task_priority === 'critical' && String(t.asigned_to) === String(assignedTo) && !COMPLETE.includes(t.status)
                                      );
                                      if (hasExistingCriticals) {
                                        setAssigneeHasCriticals(true);
                                        setShowCriticalPrompt(true);
                                      } else {
                                        setTaskPriority('critical');
                                        setBumpToFront(true);
                                      }
                                    } else {
                                      setTaskPriority('normal');
                                      setBumpToFront(false);
                                    }
                                  }}
                                  style={{
                                    display: 'flex', alignItems: 'center', gap: '8px',
                                    padding: '8px 12px', cursor: 'pointer', fontSize: '13px',
                                    fontWeight: taskPriority === opt.value ? '600' : '400',
                                    background: taskPriority === opt.value ? '#f5f5f5' : '#fff',
                                    color: opt.value === 'critical' ? '#FF4D4F' : '#1D1D1D',
                                  }}
                                >
                                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: opt.color, flexShrink: 0 }} />
                                  {opt.label}
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                        {/* Critical scheduling prompt */}
                        {showCriticalPrompt && (
                          <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.35)' }}
                            onClick={() => setShowCriticalPrompt(false)}>
                            <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '360px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', position: 'relative' }}
                              onClick={e => e.stopPropagation()}>
                              <button
                                style={{ position: 'absolute', top: '12px', right: '12px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '20px', color: '#888', lineHeight: 1, padding: '0' }}
                                onClick={() => setShowCriticalPrompt(false)}
                              >×</button>
                              <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '8px', color: '#1D1D1D' }}>Set Critical Priority</div>
                              <div style={{ fontSize: '13px', color: '#555', marginBottom: '20px', lineHeight: '1.5' }}>
                                Critical tasks are scheduled before all normal tasks. How should the engine handle the assignee's current task?
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <button
                                  style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #FF4D4F', background: '#fff1f0', color: '#FF4D4F', fontWeight: '600', cursor: 'pointer', textAlign: 'left', fontSize: '13px' }}
                                  onClick={() => {
                                    setTaskPriority('critical');
                                    setBumpToFront(true);
                                    setStatus('In-Progress');
                                    setShowCriticalPrompt(false);
                                    if (assigneeHasCriticals) {
                                      // There are existing critical tasks — open the ordering modal.
                                      // Use already-loaded depTaskList instead of fetching all tasks again.
                                      setShowCriticalOrderModal(true);
                                      const newPlaceholder = { id: '__new__', title: title?.trim() || 'New task (being created)', _isNew: true };
                                      const COMPLETE = ['Complete', 'Completed', 'Done', 'Closed', 'Cancelled', 'cancelled', 'completed'];
                                      const targetAssignedToId = (typeof assignedTo === 'object' && assignedTo !== null) ? assignedTo.id : assignedTo;
                                      const existingCriticals = depTaskList
                                        .filter(t => {
                                          const isCrit = t.task_priority === 'critical' || t.priority === 'critical' || String(t.priority_name).toLowerCase() === 'critical';
                                          const taskAssignedToId = (typeof t.asigned_to === 'object' && t.asigned_to !== null) ? t.asigned_to.id : t.asigned_to;
                                          const isSameAssignee = String(taskAssignedToId) === String(targetAssignedToId);
                                          const isNotComplete = !COMPLETE.some(s => s.toLowerCase() === String(t.status || '').toLowerCase());
                                          return isCrit && isSameAssignee && isNotComplete;
                                        })
                                        .sort((a, b) => (a.critical_order ?? 999999) - (b.critical_order ?? 999999));
                                      setCriticalOrderList([newPlaceholder, ...existingCriticals]);
                                      setLoadingCriticals(false);
                                    }
                                    // else: no existing criticals — bumpToFront=true + status=In-Progress is enough;
                                    // backend will demote the current in-progress task and promote this one
                                  }}
                                >
                                  Stop current task now &amp; start this critical task immediately
                                </button>
                                <button
                                  style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #E8E8E8', background: '#F2F2F2', color: '#1D1D1D', fontWeight: '600', cursor: 'pointer', textAlign: 'left', fontSize: '13px' }}
                                  onClick={() => { setTaskPriority('critical'); setBumpToFront(false); setShowCriticalPrompt(false); }}
                                >
                                  Wait for current task to finish, then schedule this critical task
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Critical task ordering modal (DnD) */}
                        {showCriticalOrderModal && (
                          <div
                            style={{ position: 'fixed', inset: 0, zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.45)' }}
                            onClick={() => { setShowCriticalOrderModal(false); setTaskPriority('normal'); setCriticalOrderList([]); setDragCriticalIdx(null); }}
                          >
                            <div
                              style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '700px', maxWidth: '95vw', maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 32px rgba(0,0,0,0.22)', position: 'relative' }}
                              onClick={e => e.stopPropagation()}
                            >
                              <button
                                style={{ position: 'absolute', top: '12px', right: '12px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '26px', color: '#888', lineHeight: 1, padding: '0' }}
                                onClick={() => { setShowCriticalOrderModal(false); setTaskPriority('normal'); setCriticalOrderList([]); setDragCriticalIdx(null); }}
                              >×</button>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                <button
                                  onClick={() => { setShowCriticalOrderModal(false); setShowCriticalPrompt(true); }}
                                  style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: '0', display: 'flex', alignItems: 'center', color: '#555', flexShrink: 0 }}
                                  title="Back"
                                >
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                                </button>
                                <span style={{ fontWeight: '700', fontSize: '15px', color: '#1D1D1D' }}>Order Critical Tasks</span>
                              </div>
                              <div style={{ fontSize: '12px', color: '#888', marginBottom: '14px' }}>Drag to set the execution order. Top = highest priority.</div>

                              {/* Table header */}
                              <div style={{ display: 'flex', alignItems: 'center', background: '#F2F2F2', borderRadius: '6px 6px 0 0', padding: '8px 0', flexShrink: 0 }}>
                                <div style={{ width: '60px', flexShrink: 0, paddingLeft: '12px' }}></div>
                                <div style={{ flex: 1, minWidth: 0, paddingLeft: '8px' }}>
                                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212529' }}>Task Title</span>
                                </div>
                                <div style={{ width: '150px', flexShrink: 0, padding: '0 8px' }}>
                                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212529' }}>Created By</span>
                                </div>
                                <div style={{ width: '140px', flexShrink: 0, padding: '0 8px' }}>
                                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#212529' }}>Due Date</span>
                                </div>
                              </div>

                              {/* Table body */}
                              <div style={{ overflowY: 'auto', maxHeight: '220px', border: '1px solid #F2F2F2', borderTop: 'none', borderRadius: '0 0 6px 6px' }}>
                                {loadingCriticals && (
                                  <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontSize: '13px' }}>Loading critical tasks...</div>
                                )}
                                {!loadingCriticals && criticalOrderList.map((task, idx) => {
                                  const creatorObj = task.task_assignee || task.assignee;
                                  const creatorName = creatorObj ? `${creatorObj.first_name || ''} ${creatorObj.last_name || ''}`.trim() : null;
                                  const dueDateDisplay = task._isNew
                                    ? (dueDate ? moment(dueDate).format('D MMM') : '—')
                                    : (task.due_date ? moment(task.due_date).format('D MMM, h:mm A') : '—');
                                  return (
                                    <div
                                      key={task.id}
                                      draggable
                                      onDragStart={() => setDragCriticalIdx(idx)}
                                      onDragOver={e => e.preventDefault()}
                                      onDrop={() => {
                                        if (dragCriticalIdx === null || dragCriticalIdx === idx) return;
                                        const updated = [...criticalOrderList];
                                        const [moved] = updated.splice(dragCriticalIdx, 1);
                                        updated.splice(idx, 0, moved);
                                        setCriticalOrderList(updated);
                                        setDragCriticalIdx(null);
                                      }}
                                      onDragEnd={() => setDragCriticalIdx(null)}
                                      style={{
                                        display: 'flex', alignItems: 'center',
                                        minHeight: '44px',
                                        borderBottom: '1px solid #f3f4f6',
                                        background: task._isNew ? '#f9fafb' : '#fff',
                                        cursor: 'grab', userSelect: 'none',
                                        opacity: dragCriticalIdx === idx ? 0.4 : 1,
                                        transition: 'opacity 0.15s ease',
                                      }}
                                    >
                                      {/* Drag handle + order badge */}
                                      <div style={{ width: '60px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px', paddingLeft: '12px' }}>
                                        <span style={{ color: '#C0C0C0', fontSize: '15px', lineHeight: 1 }}>⠿</span>
                                        <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#0DDFAB', color: '#000', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{idx + 1}</span>
                                      </div>
                                      {/* Task Title */}
                                      <div style={{ flex: 1, minWidth: 0, paddingLeft: '8px', paddingRight: '8px' }}>
                                        <span style={{ fontSize: '13px', fontWeight: task._isNew ? '600' : '500', color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{task.title}</span>
                                        {task._isNew && <span style={{ fontSize: '11px', color: '#0DDFAB' }}>Being created now</span>}
                                      </div>
                                      {/* Creator */}
                                      <div style={{ width: '150px', flexShrink: 0, padding: '0 8px', overflow: 'hidden' }}>
                                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                                          {task._isNew ? '—' : (creatorName || '—')}
                                        </span>
                                      </div>
                                      {/* Due Date */}
                                      <div style={{ width: '140px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <i className="uil-calendar-alt" style={{ fontSize: '16px', color: '#0DDFAB', flexShrink: 0 }} />
                                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{dueDateDisplay}</span>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>

                              <button
                                style={{ marginTop: '16px', padding: '10px', borderRadius: '8px', border: 'none', background: '#0DDFAB', color: '#000', fontWeight: '700', cursor: 'pointer', fontSize: '13px' }}
                                onClick={() => {
                                  const allIds = criticalOrderList.map(t => t.id);
                                  pendingReorderRef.current = allIds;
                                  // If the new task placeholder is at position 1, it must start
                                  // immediately — send bump_to_front so the backend promotes it
                                  // to In Progress and demotes any existing in-progress task.
                                  const isAtTop = allIds[0] === '__new__';
                                  setBumpToFront(isAtTop);
                                  // Check dependencies using already-existing tasks (not '__new__').
                                  // The full reorder (including the real new task ID) fires after creation.
                                  const existingIds = allIds.filter(id => id !== '__new__');
                                  if (existingIds.length > 0) {
                                    TaskServices.reorderCritical({ orderedIds: existingIds, company_id: companyId })
                                      .then((res) => {
                                        if (res?.blockedTasks?.length > 0) {
                                          const names = res.blockedTasks.map(t => `"${t.title}"`).join(', ');
                                          message.info(`Order saved. ${names} ${res.blockedTasks.length === 1 ? 'has' : 'have'} unfinished dependencies — ${res.blockedTasks.length === 1 ? 'it' : 'they'} will be scheduled at the selected position once the dependencies are completed.`, 6);
                                        }
                                      })
                                      .catch(() => {});
                                  }
                                  setShowCriticalOrderModal(false);
                                }}
                              >
                                Confirm Order
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      ) : (
                      /* Non-head user: static Normal badge, no interaction */
                      <div className="action-btn-wrap" style={{ cursor: 'default' }}>
                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0, backgroundColor: '#0DDFAB' }} />
                        <span>Normal</span>
                      </div>
                    )}

                    {/* Status (Custom modern dropdown) */}
                    <div className="status-select-container position-relative">
                      <Tooltip title="Task Status" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          onClick={() => setIsStatusMenuOpen(!isStatusMenuOpen)}
                          style={{ borderColor: statusError ? '#ff4d4f' : (isStatusMenuOpen || status) ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: status ? '#1D1D1D' : (statusError ? '#ff4d4f' : '#A0A0A0'), mask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/taskstatusmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: status ? '#1D1D1D' : (statusError ? '#ff4d4f' : '#A0A0A0') }}>
                            {status === "Pending" ? "Pending" : status === "In-Progress" ? "In Progress" : status === "On-Hold" ? "On Hold" : status === "Complete" ? "Complete" : "Task Status"}
                          </span>

                        </div>
                      </Tooltip>

                      {isStatusMenuOpen && (
                        <div className="custom-priority-dropdown" style={{ width: '160px' }}>
                          <div className="priority-list-scroll">
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("Pending");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#DFA70D', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>Pending</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("In-Progress");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#607EF9', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>In Progress</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("On-Hold");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#0DDFAB', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>On Hold</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => {
                                setStatus("Complete");
                                setStatusError("");
                                setIsStatusMenuOpen(false);
                              }}
                            >
                              <span style={{ backgroundColor: '#1CB333', width: '8px', height: '8px', borderRadius: '50%', marginRight: '8px' }} />
                              <span>Complete</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Approval Required (Custom modern dropdown) */}
                    <div className="approval-select-container position-relative">
                      <Tooltip title="Approval Required" placement="top">
                        <div
                          className="action-btn-wrap cursor-pointer"
                          onClick={() => setIsApprovalMenuOpen(!isApprovalMenuOpen)}
                          style={{ borderColor: '#1D1D1D' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: '#1D1D1D', mask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/approvalrequiredmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: '#1D1D1D' }}>
                            {approval === 1 ? "Yes" : "No"}
                          </span>
                        </div>
                      </Tooltip>

                      {isApprovalMenuOpen && (
                        <div className="custom-priority-dropdown" style={{ width: '120px' }}>
                          <div className="priority-list-scroll">
                            <div
                              className="priority-option-item"
                              onClick={() => { setApproval(1); setIsApprovalMenuOpen(false); }}
                            >
                              <span>Yes</span>
                            </div>
                            <div
                              className="priority-option-item"
                              onClick={() => { setApproval(0); setIsApprovalMenuOpen(false); }}
                            >
                              <span>No</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Recurring (Custom modern dropdown) */}
                    <div className="recurring-select-container position-relative">
                      <Tooltip title="Recurring Task" placement="top">
                        <div
                          className={`action-btn-wrap cursor-pointer ${isRecurring ? 'active-pill' : ''}`}
                          onClick={() => setIsRecurringMenuOpen(!isRecurringMenuOpen)}
                          style={{ borderColor: (isRecurringMenuOpen || isRecurring) ? '#1D1D1D' : '#E8E8E8' }}
                        >
                          <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: isRecurring ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/recurringtaskmodal.svg') no-repeat center / contain" }} />
                          <span style={{ fontSize: '11px', fontWeight: '600', color: isRecurring ? '#1D1D1D' : '#A0A0A0' }}>Recurring Task</span>

                        </div>
                      </Tooltip>

                      {isRecurringMenuOpen && (
                        <div className="custom-recurring-dropdown" style={isRecurring ? { top: 'auto', bottom: 'calc(100% + 5px)', marginTop: 0, marginBottom: 0 } : {}}>
                          <div className="recurring-menu-content">
                            {/* Enable Toggle */}
                            <div className="d-flex align-items-center justify-content-between mb-1 pb-1 border-bottom">
                              <span style={{ fontSize: '14px', fontWeight: '600', color: '#1D1D1D' }}>Enable Recurring</span>
                              <div className="form-check form-switch m-0">
                                <input
                                  className="form-check-input custom-switch"
                                  type="checkbox"
                                  checked={isRecurring}
                                  onChange={(e) => setIsRecurring(e.target.checked)}
                                />
                              </div>
                            </div>

                            {isRecurring && (
                              <>
                                {/* Period (Custom modern dropdown inside Recurring menu) */}
                                <div className="recurring-section">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurringperiodmodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">Recurrence Period</span>
                                  </div>
                                  <div className="recurrence-period-select-container position-relative">
                                    <div
                                      className="recurring-custom-select-trigger"
                                      onClick={() => setIsRecurrencePeriodMenuOpen(!isRecurrencePeriodMenuOpen)}
                                      style={{ color: recurringPeriod ? '#1D1D1D' : '#A0A0A0' }}
                                    >
                                      <span>{recurringPeriod ? recurringPeriod.charAt(0).toUpperCase() + recurringPeriod.slice(1) : "+ Add Period"}</span>
                                      <i className={`uil uil-angle-down`} style={{ transition: 'transform 0.2s', transform: isRecurrencePeriodMenuOpen ? 'rotate(180deg)' : 'none' }} />
                                    </div>

                                    {isRecurrencePeriodMenuOpen && (
                                      <div className="custom-priority-dropdown" style={{ width: '100%', left: '0', top: '100%' }}>
                                        <div className="priority-list-scroll">
                                          {["daily", "weekly", "monthly", "annually"].map(p => (
                                            <div
                                              key={p}
                                              className="priority-option-item"
                                              onClick={() => {
                                                setRecurringPeriod(p);
                                                setIsRecurrencePeriodMenuOpen(false);
                                                setRecurringExcludeDays([]);
                                                setRecurringWeekDay("");
                                                setRecurringMonthDate("");
                                                setRecurringAnnualMonth("");
                                                setRecurringAnnualDate("");
                                              }}
                                            >
                                              <span>{p.charAt(0).toUpperCase() + p.slice(1)}</span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Exclude Days — only shown when Daily is selected */}
                                {recurringPeriod === "daily" && (
                                  <div className="recurring-section">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <i className="uil uil-ban section-icon" />
                                      <span className="section-label">Exclude Days</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                      {[
                                        { key: "monday", label: "Mon" },
                                        { key: "tuesday", label: "Tue" },
                                        { key: "wednesday", label: "Wed" },
                                        { key: "thursday", label: "Thu" },
                                        { key: "friday", label: "Fri" },
                                        { key: "saturday", label: "Sat" },
                                        { key: "sunday", label: "Sun" },
                                      ].map(({ key, label }) => {
                                        const isExcluded = recurringExcludeDays.includes(key);
                                        return (
                                          <button
                                            key={key}
                                            type="button"
                                            onClick={() => setRecurringExcludeDays(prev =>
                                              isExcluded ? prev.filter(d => d !== key) : [...prev, key]
                                            )}
                                            style={{
                                              padding: '3px 7px',
                                              borderRadius: '6px',
                                              border: `1px solid ${isExcluded ? '#1D1D1D' : '#E8E8E8'}`,
                                              background: isExcluded ? '#1D1D1D' : '#fff',
                                              color: isExcluded ? '#fff' : '#A0A0A0',
                                              fontSize: '11px',
                                              fontWeight: '600',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {label}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}

                                {/* Weekly — Day of Week (single select) */}
                                {recurringPeriod === "weekly" && (
                                  <div className="recurring-section">
                                    <div className="d-flex align-items-center gap-2 mb-1">
                                      <i className="uil uil-calendar-alt section-icon" />
                                      <span className="section-label">Day of Week</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                      {[
                                        { key: "monday",    label: "Mon" },
                                        { key: "tuesday",   label: "Tue" },
                                        { key: "wednesday", label: "Wed" },
                                        { key: "thursday",  label: "Thu" },
                                        { key: "friday",    label: "Fri" },
                                        { key: "saturday",  label: "Sat" },
                                        { key: "sunday",    label: "Sun" },
                                      ].map(({ key, label }) => {
                                        const isSelected = recurringWeekDay === key;
                                        return (
                                          <button
                                            key={key}
                                            type="button"
                                            onClick={() => setRecurringWeekDay(isSelected ? "" : key)}
                                            style={{
                                              padding: '3px 7px',
                                              borderRadius: '6px',
                                              border: `1px solid ${isSelected ? '#1D1D1D' : '#E8E8E8'}`,
                                              background: isSelected ? '#1D1D1D' : '#fff',
                                              color: isSelected ? '#fff' : '#A0A0A0',
                                              fontSize: '11px',
                                              fontWeight: '600',
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {label}
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}

                                {/* Monthly — Date of Month */}
                                {recurringPeriod === "monthly" && (
                                  <div className="recurring-section">
                                    <div className="d-flex align-items-center gap-2 mb-0">
                                      <i className="uil uil-calendar-alt section-icon" />
                                      <span className="section-label">Date of Month</span>
                                    </div>
                                    <DatePicker
                                      value={recurringMonthDate ? moment().date(recurringMonthDate) : null}
                                      onChange={(date) => {
                                        if (date) setRecurringMonthDate(date.date());
                                        else setRecurringMonthDate("");
                                      }}
                                      format="DD"
                                      bordered={false}
                                      placeholder="+ Select Date"
                                      className="recurring-inline-timepicker"
                                      suffixIcon={null}
                                      allowClear={false}
                                      style={{ color: recurringMonthDate ? '#1D1D1D' : '#A0A0A0' }}
                                      getPopupContainer={(trigger) => trigger.parentNode}
                                    />
                                  </div>
                                )}

                                {/* Annually — single DatePicker for month + day */}
                                {recurringPeriod === "annually" && (
                                  <div className="recurring-section">
                                    <div className="d-flex align-items-center gap-2 mb-0">
                                      <i className="uil uil-calendar-alt section-icon" />
                                      <span className="section-label">Date &amp; Month</span>
                                    </div>
                                    <DatePicker
                                      value={
                                        recurringAnnualMonth && recurringAnnualDate
                                          ? moment().month(recurringAnnualMonth - 1).date(recurringAnnualDate)
                                          : null
                                      }
                                      onChange={(date) => {
                                        if (date) {
                                          setRecurringAnnualMonth(date.month() + 1);
                                          setRecurringAnnualDate(date.date());
                                        } else {
                                          setRecurringAnnualMonth("");
                                          setRecurringAnnualDate("");
                                        }
                                      }}
                                      format="DD MMMM"
                                      bordered={false}
                                      placeholder="+ Select Date &amp; Month"
                                      className="recurring-inline-timepicker"
                                      suffixIcon={null}
                                      allowClear={false}
                                      style={{ color: (recurringAnnualMonth && recurringAnnualDate) ? '#1D1D1D' : '#A0A0A0' }}
                                      getPopupContainer={(trigger) => trigger.parentNode}
                                    />
                                  </div>
                                )}

                                {/* Time */}
                                <div className="recurring-section">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/runtimemodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">Run Time</span>
                                  </div>
                                  <TimePicker
                                    value={recurringTime ? moment(recurringTime, 'HH:mm') : null}
                                    onChange={(time, timeString) => setRecurringTime(timeString)}
                                    format="HH:mm"
                                    bordered={false}
                                    placeholder="+ Add Time"
                                    className="recurring-inline-timepicker"
                                    suffixIcon={null}
                                    allowClear={false}
                                    style={{ color: recurringTime ? '#1D1D1D' : '#A0A0A0' }}
                                    getPopupContainer={(trigger) => trigger.parentNode}
                                  />
                                </div>

                                {/* No. of Recurrences */}
                                <div className="recurring-section border-0 pb-0">
                                  <div className="d-flex align-items-center gap-2 mb-0">
                                    <span className="section-icon" style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: '#1D1D1D', mask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/recurrencesmodal.svg') no-repeat center / contain" }} />
                                    <span className="section-label">No. of Recurrences</span>
                                  </div>
                                  <input
                                    type="number"
                                    className="recurring-inline-input"
                                    placeholder="+ Add No"
                                    value={recurringTotalCount || ""}
                                    onChange={(e) => setRecurringTotalCount(parseInt(e.target.value) || 0)}
                                    style={{ color: recurringTotalCount ? '#1D1D1D' : '#A0A0A0' }}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Dependencies — gated by Advanced Task Module */}
                    {hasAdvancedTaskModule && (
                      <div className="dep-select-container position-relative">
                        <Tooltip title="Link a task that must finish before this one starts" placement="top">
                          <div
                            className="action-btn-wrap cursor-pointer"
                            style={{ borderColor: (depSearchOpen || dependsOn.length > 0) ? '#1D1D1D' : '#E8E8E8' }}
                            onClick={() => setDepSearchOpen(!depSearchOpen)}
                          >
                            <span style={{ display: 'inline-block', width: '15px', height: '15px', flexShrink: 0, backgroundColor: (depSearchOpen || dependsOn.length > 0) ? '#1D1D1D' : '#A0A0A0', mask: "url('/assets/images/dependencies.svg') no-repeat center / contain", WebkitMask: "url('/assets/images/dependencies.svg') no-repeat center / contain" }} />
                            <span style={{ fontSize: '11px', fontWeight: '600', color: (depSearchOpen || dependsOn.length > 0) ? '#1D1D1D' : '#A0A0A0' }}>Dependencies {dependsOn.length > 0 ? `(${dependsOn.length})` : ''}</span>
                          </div>
                        </Tooltip>
                        {depSearchOpen && (
                          <div className="custom-user-dropdown" style={{ minWidth: '240px' }}>
                            <div className="search-header">
                              <i className="uil uil-search" />
                              <input
                                autoFocus
                                value={depSearchTerm}
                                onChange={(e) => setDepSearchTerm(e.target.value)}
                                placeholder="Search tasks..."
                              />
                            </div>
                            <div className="user-list-scroll">
                              {(depTaskList.filter(t =>
                                !['Complete', 'Completed', 'Done', 'Closed', 'Cancelled', 'cancelled', 'completed'].includes(t.status) &&
                                !dependsOn.some(d => String(d.id) === String(t.id)) &&
                                t.title?.toLowerCase().includes(depSearchTerm.toLowerCase())
                              ).slice(0, 20)).map(t => {
                                const initials = t.title.trim().split(/\s+/).map(w => w[0]).join('').toUpperCase().substring(0, 2);
                                return (
                                  <div
                                    key={t.id}
                                    className="user-option-item"
                                    onClick={() => {
                                      setDependsOn(prev => [...prev, t]);
                                      setDepSearchTerm("");
                                    }}
                                  >
                                    <div className="user-avatar-mini">{initials}</div>
                                    <span>{t.title}</span>
                                  </div>
                                );
                              })}
                              {localTaskList === null && props.allTasks === undefined ? (
                                <div className="no-users-found">Loading...</div>
                              ) : depTaskList.filter(t =>
                                !['Complete', 'Completed', 'Done', 'Closed', 'Cancelled', 'cancelled', 'completed'].includes(t.status) &&
                                !dependsOn.some(d => String(d.id) === String(t.id)) &&
                                t.title?.toLowerCase().includes(depSearchTerm.toLowerCase())
                              ).length === 0 && (
                                <div className="no-users-found">No tasks found</div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* ── Dependencies Table — exact mirror of EditTask dependency section ── */}
                {hasAdvancedTaskModule && dependsOn.length > 0 && (() => {
                  const STATUS_CONFIG = {
                    "Complete": { bg: "#e8fdf0", color: "#1CB333", text: "Complete" },
                    "In Progress": { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
                    "In-Progress": { bg: "#eef0fe", color: "#607EF9", text: "In Progress" },
                    "Pending": { bg: "#fef9ec", color: "#DFA70D", text: "Pending" },
                    "On Hold": { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
                    "On-Hold": { bg: "#e0fdf8", color: "#0DDFAB", text: "On Hold" },
                    "Pending-Approval": { bg: "#ebebeb", color: "#1D1D1D", text: "Pending Approval" },
                    "Rejected": { bg: "#ffebeb", color: "#FF0000", text: "Rejected" },
                  };
                  const getStatusBadge = (status) => {
                    const s = STATUS_CONFIG[status] || { bg: "#f1f5f9", color: "#475569", text: status || "—" };
                    return (
                      <span style={{ background: s.bg, color: s.color, padding: "4px 12px", borderRadius: "8px", fontSize: "13px", fontWeight: "600", whiteSpace: "nowrap", display: "inline-block" }}>
                        {s.text}
                      </span>
                    );
                  };
                  return (
                    <div className="col-12 mb-2">
                      <div className="section-header" style={{ marginTop: '0', marginBottom: '12px' }}>Dependencies</div>

                      {/* Table header — exact match to EditTask */}
                      <div className="task-list-header-edit">
                        <div style={{ flex: 1, minWidth: 0, paddingLeft: '12px', display: 'flex', alignItems: 'center' }}><span>Task Title</span></div>
                        <div style={{ width: '110px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Created By</span></div>
                        <div style={{ width: '110px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Assigned To</span></div>
                        <div style={{ width: '90px', flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center' }}><span>Due Date</span></div>
                        <div style={{ width: '140px', flexShrink: 0, padding: '0 6px', display: 'flex', alignItems: 'center' }}><span>Status</span></div>
                        <div style={{ width: '36px', flexShrink: 0 }} />
                      </div>

                      <div className="subtask-list-container" style={{ maxHeight: '132px', overflowY: 'auto' }}>
                        {dependsOn.map(dep => {
                          const assigneeObj = dep.asignedd_to || dep.task_assigned_to || null;
                          const assigneeName = assigneeObj ? `${assigneeObj.first_name || ""} ${assigneeObj.last_name || ""}`.trim() : "";
                          const creatorId = dep.created_by?.id || dep.created_by;
                          const creatorObj = creatorId ? (props.taskOwner || []).find(u => String(u.id) === String(creatorId)) : null;
                          const creatorName = creatorObj ? (creatorObj.full_name || `${creatorObj.first_name || ""} ${creatorObj.last_name || ""}`.trim()) : "";
                          const priorityObj = (props.priority || []).find(p => String(p.id) === String(dep.priority));
                          const priorityColor = priorityObj?.color || null;
                          const priorityName = priorityObj?.name || null;
                          return (
                            <div key={dep.id} className="task-row-edit">
                              {/* Priority indicator */}
                              {priorityColor && (
                                <div className="priority-indicator-edit" style={{ backgroundColor: priorityColor }}>
                                  <span>{priorityName}</span>
                                </div>
                              )}

                              {/* Title */}
                              <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px', paddingLeft: priorityColor ? '8px' : '12px', paddingRight: '8px', overflow: 'hidden' }}>
                                <span style={{ fontSize: '13px', fontWeight: '500', color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                                  {dep.title}
                                </span>
                              </div>

                              {/* Created By */}
                              <div style={{ width: '110px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden', padding: '0 8px' }}>
                                {creatorObj && (
                                  <>
                                    <UserProfile username={creatorName} userImage={creatorObj.image} style={{ width: '20px', height: '20px', flexShrink: 0, borderRadius: '4px' }} />
                                    <span className="subtask-user-name" style={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{creatorName}</span>
                                  </>
                                )}
                              </div>

                              {/* Assigned To */}
                              <div style={{ width: '110px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden', padding: '0 8px' }}>
                                {assigneeObj && (
                                  <>
                                    <UserProfile username={assigneeName} userImage={assigneeObj.image} style={{ width: '20px', height: '20px', flexShrink: 0, borderRadius: '4px' }} />
                                    <span className="subtask-user-name" style={{ fontSize: '11px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{assigneeName}</span>
                                  </>
                                )}
                              </div>

                              {/* Due Date */}
                              <div style={{ width: '90px', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '4px', overflow: 'hidden', padding: '0 8px' }}>
                                <i className="uil-calendar-alt" style={{ fontSize: '18px', color: '#0DDFAB', flexShrink: 0 }} />
                                <span style={{ fontSize: '12px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                  {dep.due_date ? moment(dep.due_date).format('D, MMM') : '—'}
                                </span>
                              </div>

                              {/* Status */}
                              <div style={{ width: '140px', flexShrink: 0, padding: '0 6px', display: 'flex', alignItems: 'center' }}>
                                {getStatusBadge(dep.status)}
                              </div>

                              {/* Remove */}
                              <div style={{ width: '36px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Tooltip title="Remove dependency">
                                  <div
                                    onClick={() => setDependsOn(prev => prev.filter(d => d.id !== dep.id))}
                                    style={{ width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', cursor: 'pointer', color: '#9ca3af' }}
                                    onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#dc2626'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#9ca3af'; }}
                                  >
                                    <i className="uil-times" style={{ fontSize: '14px' }} />
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}

                {/* ── Footer Actions ───────────────────────────────────── */}
                <div className="col-12 d-flex align-items-center justify-content-between mt-2 pt-2 border-top">
                  <div className="d-flex align-items-center gap-3">
                    <Tooltip title="Attach Files" placement="top">
                      <div
                        className="attachment-trigger"
                        style={{ cursor: 'pointer' }}
                        onClick={() => fileInputRef.current?.click()}
                      >
                        <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: '#1a1a1a', mask:"url('/assets/images/attachmentmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/attachmentmodal.svg') no-repeat center / contain" }} />
                      </div>
                    </Tooltip>
                    <input
                      ref={fileInputRef}
                      type="file"
                      style={{ display: 'none' }}
                      onChange={addAttachment}
                    />
                    {attachments.length > 0 && (
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        {(showAllAttachments ? attachments : attachments.slice(0, 3)).map((file, index) => (
                          <div
                            key={index}
                            className="attachment-preview-chip cursor-pointer"
                            onClick={() => previewAttachment(file)}
                          >
                            <i className="uil uil-import chip-download-icon" />
                            <span className="chip-file-name">
                              {file.name.length > 20 ? file.name.substring(0, 15) + '...' + file.name.split('.').pop() : file.name}
                            </span>
                            <i
                              className="uil uil-times chip-remove-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeAttachment(index);
                              }}
                            />
                          </div>
                        ))}
                        {attachments.length > 3 && (
                          <div
                            className="attachment-preview-chip cursor-pointer"
                            onClick={() => setShowAllAttachments(!showAllAttachments)}
                            style={{ background: '#f8f9fa', border: '1px dashed #adb5bd', color: '#1D1D1D' }}
                          >
                            <span style={{ fontWeight: 600 }}>
                              {showAllAttachments ? "Show Less" : `+ ${attachments.length - 3} more`}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: "16px", flexShrink: 0 }}>
                    {/* Optional (Notes): close the form and keep the note as it is */}
                    {props.secondaryAction && (
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ color: "#1D1D1D", fontSize: "13px", fontWeight: 600, textDecoration: "none", boxShadow: "none" }}
                        onClick={() => { document.getElementById(closeBtnId || "taskClose")?.click(); props.secondaryAction.onClick?.(); }}
                      >
                        {props.secondaryAction.label}
                      </button>
                    )}
                    <button
                      type="submit"
                      className="btn-create-task"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <div className="spinner-border spinner-border-sm me-2" role="status" />
                      ) : (
                        <i className="uil uil-plus me-1" style={{ fontSize: '16px' }} />
                      )}
                      Create Task
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>{`
        .task-title-float-wrap input {
          border-radius: 12px !important;
          height: 44px !important;
          padding: 0 16px !important;
          font-size: 17px !important;
          font-weight: 500 !important;
          border: 1.5px solid transparent !important;
          transition: all 0.2s ease !important;
        }
        .task-title-float-wrap input::placeholder {
          color: #a0a0a0 !important;
          font-size: 17px !important;
          font-weight: 500 !important;
        }
        .task-title-float-wrap input:hover, .task-title-float-wrap input:focus { border-color: #1D1D1D !important; }
        .task-title-float-wrap label {
          left: 16px !important;
          top: 50% !important;
          font-size: 17px !important;
          opacity: 0 !important; 
          transition: all 0.2s ease !important;
          pointer-events: none;
          background: #fff !important;
          z-index: 99 !important;
          padding: 0 5px;
        }
        /* Show label ONLY when focused */
        .task-title-float-wrap input:focus ~ label {
          top: 0 !important;
          font-size: 12px !important;
          opacity: 1 !important;
          background: #fff !important;
          z-index: 99 !important;
        }
        .task-title-float-wrap input:focus::placeholder {
          color: transparent !important;
        }

        .task-desc-float-wrap {
          position: relative;
          border-radius: 12px;
          border: 1.5px solid transparent;
          transition: all 0.2s ease;
          margin-top: 14px;
        }
        .task-desc-float-wrap:hover, .task-desc-float-wrap.focused { border-color: #1D1D1D !important; }

        /* Popover Styling */
        .link-popover {
          background: #fff;
          border: 1.5px solid #1D1D1D;
          border-radius: 10px;
          padding: 4px;
          bottom: 50px !important;
          left: 10px !important;
          width: 320px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .link-popover input {
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          font-size: 14px !important;
          padding: 8px 12px !important;
        }
        .link-popover input:focus {
          border: none !important;
          border-color: transparent !important;
          box-shadow: none !important;
          outline: none !important;
        }
        .action-datepicker {
          width: 52px !important;
          padding: 0 !important;
          margin-left: -8px !important;
        }
        .action-datepicker input {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #000 !important;
          padding-left: 0 !important;
          margin-left: 0 !important;
          cursor: pointer !important;
        }
        .link-apply-btn {
          background-color: #0DDFAB !important;
          border: none !important;
          color: #000 !important;
          font-weight: 600 !important;
          border-radius: 8px !important;
          padding: 6px 16px !important;
          font-size: 13px !important;
        }

        /* Quill Specific Styles */
        .quill {
          width: 100%;
          border-radius: 10px;
          overflow: hidden;
        }
        .ql-container.ql-snow {
          border: none !important;
          font-family: inherit !important;
        }
        .ql-editor {
          padding: 12px 16px 8px 48px !important;
          min-height: 44px !important;
          max-height: 200px !important;
          overflow-y: auto !important;
          font-size: 15px !important;
          transition: all 0.2s ease;
          cursor: text !important;
          outline: none !important;
          border: none !important;
        }
        .task-desc-float-wrap.focused .ql-editor,
        .task-desc-float-wrap.has-value .ql-editor,
        .task-desc-float-wrap .ql-editor:not(.ql-blank) {
          padding-left: 16px !important;
        }
        .ql-editor.ql-blank::before {
          display: none !important;
        }

        .task-desc-float-wrap .desc-icon {
          position: absolute;
          left: 16px;
          top: 13px !important;
          transform: none !important;
          color: #a0a0a0;
          transition: all 0.2s ease;
          pointer-events: none;
          z-index: 10;
          opacity: 1;
        }
        .task-desc-float-wrap.focused .desc-icon,
        .task-desc-float-wrap.has-value .desc-icon {
          opacity: 0 !important;
        }

        .task-desc-float-wrap label {
          position: absolute;
          left: 48px;
          top: 12px !important;
          transform: none !important;
          font-size: 17px !important;
          line-height: 20px !important;
          color: #a0a0a0;
          transition: all 0.2s ease !important;
          pointer-events: none;
          background: #fff !important;
          padding: 0 5px;
          z-index: 99 !important;
          opacity: 1;
          width: auto !important;
        }
        .task-desc-float-wrap.focused label,
        .task-desc-float-wrap.has-value label {
          top: 0 !important;
          transform: translateY(-50%) !important;
          left: 12px !important;
          font-size: 12px !important;
          color: #1D1D1D !important;
          opacity: 1 !important;
          background: #fff !important;
          z-index: 99 !important;
        }
        .task-desc-float-wrap.has-value:not(.focused) label {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }

        .desc-toolbar {
          display: flex;
          gap: 4px;
          background: #F5F5F5;
          padding: 2px 4px;
          border-radius: 6px;
          width: fit-content;
          margin: 0 0 6px 16px;
          opacity: 0;
          visibility: hidden;
          pointer-events: none !important;
          transition: all 0.2s ease;
          border: none !important;
        }
        .task-desc-float-wrap.focused .desc-toolbar {
          opacity: 1;
          visibility: visible;
          pointer-events: auto !important;
        }
        .toolbar-btn {
          background: transparent !important;
          border: none !important;
          padding: 0 !important;
          border-radius: 4px;
          color: #1D1D1D !important;
          font-size: 14px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.2s ease;
          cursor: pointer;
          width: 26px !important;
          height: 26px !important;
        }
        .toolbar-btn i {
          display: block !important;
          visibility: visible !important;
          color: #1D1D1D !important;
          font-size: 14px !important;
        }
        .toolbar-btn:hover {
          background: #E8E8E8 !important;
        }
        .ql-snow .ql-stroke {
          display: none !important; /* Hide default Quill strokes if any */
        }
        .ql-snow .ql-fill {
          display: none !important;
        }
        /* Active state for icons */
        .ql-snow.ql-toolbar button.ql-active i {
          color: #0DDFAB !important;
        }

        ::selection {
          background: #0DDFAB !important;
          color: #000000 !important;
        }

        /* Effort hours inline input inside action-btn-wrap pill */
        input.effort-btn-input {
          width: 28px !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          background: transparent !important;
        }
        input.effort-btn-input:focus {
          border: none !important;
          border-color: transparent !important;
          box-shadow: none !important;
          outline: none !important;
        }

        .action-btn-wrap {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 4px 8px;
          border: 1px solid #E8E8E8;
          border-radius: 5px;
          background: #fff;
          transition: all 0.2s ease;
          min-width: fit-content;
          height: 30px;
        }
        .action-btn-wrap:hover, .action-btn-wrap:focus-within {
          border-color: #1D1D1D;
        }
        
        .action-icon {
          font-size: 16px;
          color: #1D1D1D;
          display: flex;
          align-items: center;
        }

        .action-select-plain {
          border: none !important;
          background: transparent !important;
          font-size: 11px;
          font-weight: 600;
          color: #1D1D1D;
          cursor: pointer;
          padding: 0;
          outline: none;
        }
        .action-select-plain option { font-weight: 400; }

        .action-datepicker {
          width: 55px !important;
          margin-left: -3px !important;
          padding: 0 !important;
        }
        .action-datepicker .ant-picker-input > input {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #000 !important;
          cursor: pointer !important;
          padding-left: 0 !important;
        }
        .action-datepicker .ant-picker-input > input::placeholder { color: #a0a0a0 !important; }

        .custom-user-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          width: 250px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          z-index: 10000;
          margin-top: 5px;
          overflow: hidden;
        }
        .search-header {
          padding: 12px 16px;
          border-bottom: 1px solid #F0F0F0;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .search-header i {
          font-size: 18px;
          color: #1a1a1a;
        }
        .search-header input {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          font-size: 14px;
          width: 100%;
          color: #1D1D1D;
          font-weight: 400;
        }
        .user-list-scroll {
          padding: 5px;
          max-height: 250px;
          overflow-y: auto;
        }
        .user-option-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 10px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 11px;
          color: #1a1a1a;
        }
        .user-option-item:hover {
          background: #f0fdf9;
        }
        .user-avatar-mini {
          width: 20px;
          height: 20px;
          background-color: #0DDFAB;
          color: #000;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 9px;
          font-weight: 700;
        }
        .section-header { font-size: 16px; font-weight: 700; color: #1D1D1D; margin: 8px 0 10px 0; }
        .subtask-list-container { overflow: visible; padding-right: 4px; }
        .subtask-user-name { font-weight: 500; color: #1D1D1D; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80px; }
        .task-list-header-edit { display: flex; align-items: center; padding: 8px 0; background: #F2F2F2; overflow: hidden; }
        .task-list-header-edit span { font-size: 13px; font-weight: 600; color: #212529; text-align: left; display: block; }
        .task-row-edit { position: relative; display: flex; width: 100%; align-items: center; min-height: 44px; border: none; padding: 4px 0; transition: background-color 0.15s; }
        .task-row-edit:hover { background-color: #f9fafb !important; }
        .priority-indicator-edit { flex-shrink: 0; align-self: stretch; width: 4px; transition: width 0.3s cubic-bezier(0.4,0,0.2,1); display: flex; align-items: center; overflow: hidden; cursor: default; border-radius: 0 4px 4px 0; }
        .priority-indicator-edit:hover { width: 50px; box-shadow: 2px 0 8px rgba(0,0,0,0.1); }
        .priority-indicator-edit span { opacity: 0; transition: opacity 0.2s ease; white-space: nowrap; font-size: 10px; font-weight: 700; color: #1d1d1d; padding-left: 6px; }
        .priority-indicator-edit:hover span { opacity: 1; transition-delay: 0.1s; }
        .custom-priority-dropdown { z-index: 10001;
          position: absolute;
          top: 100%;
          left: 0;
          width: 150px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          z-index: 10000;
          margin-top: 5px;
          overflow: hidden;
        }
        .priority-list-scroll {
          padding: 5px;
        }
        .priority-option-item {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 11px;
          color: #1a1a1a;
          font-weight: 500;
        }
        .priority-option-item:hover {
          background: #f0fdf9;
        }

        .custom-recurring-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          width: 260px;
          background: #fff;
          border: 1px solid #E8E8E8;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
          z-index: 10000;
          margin-top: 5px;
        }
        .recurring-menu-content {
          padding: 12px;
        }
        .recurring-section {
          margin-bottom: 4px; padding-bottom: 2px;
          border-bottom: 1px solid #F5F5F5;
        }
        .section-icon {
          font-size: 16px;
          color: #1D1D1D;
        }
        .section-label {
          font-size: 13px;
          font-weight: 600;
          color: #1D1D1D;
        }
                .recurring-inline-input {
          width: calc(100% - 30px) !important;
          margin-left: 26px !important;
          height: 34px !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background: transparent !important;
          appearance: textfield;
        }
        .recurring-inline-input::-webkit-outer-spin-button,
        .recurring-inline-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .recurring-custom-select-trigger, .recurring-inline-select, 
        .recurring-inline-input,
        .recurring-inline-timepicker {
          width: 100%;
          border: none !important;
          outline: none !important;
          padding: 0 !important;
          font-size: 12px !important;
          background: transparent !important;
          cursor: pointer;
          font-weight: 500;
          margin-left: 26px;
          width: calc(100% - 26px);
        }
                .recurring-custom-select-trigger {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: calc(100% - 26px);
          margin-left: 26px;
          height: 34px;
          min-height: 34px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .recurring-custom-select-trigger:hover {
          color: #1D1D1D !important;
        }

        .recurring-inline-select:focus,
        .recurring-inline-input:focus {
          color: #1D1D1D !important;
        }
        .recurring-inline-select option {
          color: #1D1D1D;
        }
        .custom-switch:checked {
          background-color: #0DDFAB !important;
          border-color: #0DDFAB !important;
        }

        .active-pill {
          border-color: #1D1D1D !important;
          background: #fff !important;
        }
        .cursor-pointer {
          cursor: pointer;
        }


        .attachment-trigger {
          width: 30px;
          height: 30px;
          border-radius: 5px;
          background: #f8f9fa;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          border: 1px solid #E8E8E8;
        }
        .attachment-trigger:hover { background: #f0f1f2; border-color: #adb5bd; }

        .btn-create-task {
          background-color: #0DDFAB;
          border: none;
          border-radius: 5px;
          height: 30px;
          padding: 0 20px;
          color: #000;
          font-weight: 700;
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          box-shadow: none !important;
          flex-shrink: 0 !important;
        }
        .btn-create-task:hover {
          background-color: #0bc698;
          transform: translateY(-2px);
        }
        .btn-create-task:active { transform: translateY(0); }
        .btn-create-task:disabled { opacity: 0.6; cursor: not-allowed; transform: none; box-shadow: none; }
        .attachment-preview-chip {
          display: flex;
          align-items: center;
          gap: 6px;
          background: #1D1D1D;
          color: #0DDFAB;
          padding: 0 8px;
          height: 24px;
          border-radius: 4px;
          font-size: 11px;
          font-weight: 500;
          transition: all 0.2s ease;
        }
        .chip-download-icon {
          font-size: 12px;
          color: #0DDFAB;
        }
        .chip-file-name {
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .chip-remove-icon {
          font-size: 14px;
          color: #0DDFAB;
          transition: transform 0.2s;
        }
        .chip-remove-icon:hover {
          transform: scale(1.2);
          color: #fff;
        }

        .recurring-inline-input:focus, 
        .recurring-inline-input:active, 
        .recurring-inline-input:focus-visible,
        .recurring-inline-select:focus,
        .recurring-inline-timepicker:focus,
        .ant-picker-focused {
          outline: none !important;
          border: none !important;
          box-shadow: none !important;
        }
      `}</style>
    </div>,
    document.body
  )}{emojiPortal}{linkPortal}</>;
};

export default CreateTask;
